import React from 'react';
import IconStar from '../Icons/IconStar';
import Wrapper from '../Wrapper';
import Text from '../Text';
import './RateResult.less';

export type RateResultProps = {
  rating: number;
  maxRating?: number;
  iconColor?: string;
  ratersCount?: string | number;
};

const RateResult: React.FC<RateResultProps> = ({
  iconColor = '#F7D10C',
  rating = 0,
  maxRating = 5,
  ratersCount,
}) => {
  return (
    <Wrapper display="flex" alignItems="center">
      <IconStar fill={iconColor} />
      <Wrapper display="flex" ml={4}>
        <Wrapper>
          <Text level={3}>
            {rating}
            <Wrapper display="inline" mx={4}>
              /
            </Wrapper>
            {maxRating}
          </Text>
        </Wrapper>

        {ratersCount && (
          <Wrapper ml={4}>
            <Text level={3} textColor="dark-30">
              ({ratersCount})
            </Text>
          </Wrapper>
        )}
      </Wrapper>
    </Wrapper>
  );
};

export default RateResult;
